 <div class="closediag">
 <h2>Close {{ data.app.name }}?</h2>
  It looks like you just closed an application.<br>
  You can choose to leave this application running if you will come back to it soon or to terminate it so that someone else may use the computing resources<br>
  <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%">
  <button mat-button (click)="close(null)">Leave it running</button><button mat-button (click)="close(data)">Terminate {{ data.app.name }}</button>
  </div>
</div>
